<!-- start: Top Toolbar and Sidenav menu -->
<div id="app-container">
    <mat-sidenav-container>
        <mat-sidenav #sidenav>
            <mat-nav-list>
                <span (click)="sidenav.toggle()" mat-list-item rel="noopener"><mat-icon class="sidenav-close-icon">clear</mat-icon></span>
                <ng-container *ngFor="let item of siteMenu">
                    <a (click)="navigateTo(item.link)" *ngIf="!item.option" (click)="sidenav.toggle()" [routerLink]="['/']" [fragment]="item.title"  mat-list-item rel="noopener"> {{ item.title }}</a>        
                        <a (click)="navigateTo(item.link)" *ngIf="item.option && item.link.length<5" (click)="sidenav.toggle()" [routerLink]="['/']" [fragment]="item.title"  mat-list-item rel="noopener"> {{ item.title }}</a>        
                        <a *ngIf="item.option && item.link.length>5" rel="noopener" (click)="sidenav.toggle()" [target]="item.option" [href]="item.link"  mat-list-item rel="noopener" > {{ item.title }}</a>        
                    <!-- <a (click)="navigate(item.link, item.option)" mat-list-item rel="noopener">
                        {{ item.title }}</a> -->
                </ng-container>
            </mat-nav-list>
        </mat-sidenav>
        <!-- start: Content -->
        <mat-sidenav-content id="mat-sidenav-content">
            <!-- <div class="site-container" > -->
            <div class="mat-sidenav-content-container" id="site-container">
                <router-outlet></router-outlet>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
<!-- end: Content -->